import moment from "moment";
export const COLUMNS = [
  {
    Header: "Arquivo",
    accessor: "nomeAutomacao",
  },
  {
    Header: "Instituição Financeira",
    accessor: "instituicao",
  },
  {
    Header: "Layout",
    accessor: "descricao",
  },
];

export const COLUMNS_LOG = [
  {
    Header: "Data da tentativa",
    accessor: "dataCriacao",
    Cell: ({ value }) => moment(value).local().format("DD/MM/YYYY HH:mm"),
    sortType: (rowA, rowB, columnId) => {
      const a = new Date(rowA.values[columnId]).getTime();
      const b = new Date(rowB.values[columnId]).getTime();
      return a - b;
    },
  },

  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Detalhes",
    accessor: "detalhes",
  },
];
